export const CO2Equivalents = {
  CO2_PER_TREE_SEEDING_IN_T : "co2_per_tree_seedings_in_t",
  NUCLEAR_WASTE_FOR_1MWH_NUCLEAR_ELECTRICITY_IN_G : "nuclear_waste_for_1mwh_nuclear_electricity_in_g",
  CO2_FOR_1KM_TRAVALLED_IN_G : "co2_for_1km_travelled_in_g",
  WORLD_TOUR_DISTANCE_IN_KM : "world_tour_distance_in_km",
  CO2_FOR_1KM_DRIVEN_IN_G : "co2_for_1km_driven_in_g",
  AVERAGE_HOUSEHOLD_ELECTRICITY_CONSUMPTION_IN_KWH : "average_household_electricity_consumption_in_kwh"
}


// WEBPACK FOOTER //
// ./src/enums/CO2Equivalents.js